import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';

export default class AzurePropertyNode extends BaseNode {
    constructor() {
        super();
        this.name = 'Azure Property';
        this.id = 'node_azure_property';
        this.linkedFeature = 'azure';

        this.inputs = [
            {
                name: 'Send',
                portId: 'azure_pub',
                params: [],
            },
        ];

        const settings: Setting[] = [
            {
                id: 'PROPERTY_ID',
                name: 'Property ID',
                settingType: SettingType.STRING,
                required: true,
                default: '',
            },
            {
                id: 'PROPERTY_VALUE',
                name: 'Property Value',
                settingType: SettingType.STRINGVARIABLE,
                required: true,
                default: '',
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getCodeBlocks(): CodeBlock[] {
        const blocks: CodeBlock[] = [];
        const project: ProjectConfiguration = this.project;
        const links = project.getNodeLinks(this, 'azure_pub');
        const PROPERTY_ID = this.getSettingValue('PROPERTY_ID');
        const PROPERTY_VALUE = this.getSettingValue('PROPERTY_VALUE');


        for (let i = 0; i < links.length; i += 1) {
            const link = links[i];
            const source: BaseNode = project.getFeature(link.getSettingValue('SOURCE_FEATURE')) as BaseNode;
            const sourceParams = source.getPort(link.getSettingValue('SOURCE_PORT'))?.params;
            const doneLinks = project.getNodeLinks(source, 'done');
            const doneBlock = doneLinks.length > 0 ? `${project.getCodeLocationStart()}${doneLinks[0].getSourceId()}${project.getCodeLocationEnd()}` : '';
            blocks.push({
                location: link.getSourceId(),
                blockType: BlockType.CODE,
                id: link.getID(),
                template: `
    azure_send_property(${project.parseCodeExpression(PROPERTY_ID, sourceParams, TibboDataType.STRING)}, ${project.parseCodeExpression(PROPERTY_VALUE, sourceParams, TibboDataType.STRING)})
    ${doneBlock}`,
            });
        }
        return blocks;
    }

    getDetails(): string {
        return 'https://docs.tibbo.com/phm/wm2000ev_demo_03';
    }
}
